import React from 'react';
import {observer} from 'mobx-react-lite';
import merge from 'lodash/merge';
import {Container, I18NText, Text} from '@yosmanyga/rich-ui';
import {useService} from '@yosmanyga/di';
import {PlayBoardController} from '../../controller';
import {ThemeBuildType, ThemeProvider, ThemeVariablesType} from "@yosmanyga/theme";

const PlayBoard = observer(() => {
    const playBoardController = useService(PlayBoardController, []);

    return playBoardController.scenery.map(({input, output}, i) => {
        return <Container key={i}>
            <I18NText
                intent="system"
                margin={{
                    top: i !== 0 ? 2 : 0,
                }}
            >
                What do you want to do?
            </I18NText>
            <Text
                intent="user"
            >
                {input}
            </Text>
            {output.map((message, i) => {
                return (
                    <Container
                        key={i}
                        onClick={() => {
                            playBoardController.select(message);
                        }}
                    >
                        <Text
                            intent="system"
                        >
                            {message}
                        </Text>
                    </Container>
                );
            })}
        </Container>
    })
});

type PlayBoardProps = {};

const PlayBoardWithTheme = (props: PlayBoardProps) => {
    return <ThemeProvider build={(variables?: ThemeVariablesType, parent?: ThemeBuildType) => {
        const {palette} = variables as ThemeVariablesType;

        const current = {
            text: {
                system_intent: {
                    color: palette.neutral['1000'],
                },
                user_intent: {
                    color: palette.neutral['0'],
                },
            },
        };

        return merge(
            {},
            parent ? parent(variables) : {},
            current,
        );
    }}>
        <PlayBoard {...props} />
    </ThemeProvider>
};

export {
    PlayBoardWithTheme as PlayBoard
};
